import { memo } from 'react'

import { useCurrentLanguage } from 'lib/tolgee'

import { useUploadListItemModel } from './upload-list-item.model'
import type { IUploadListItemProps } from './upload-list-item.types'
import { UploadListItemView } from './upload-list-item.view'

const Component = ({
  fileExtension,
  fileSize,
  uploadDate,
  children,
  documentId,
  disabled,
  onDelete,
  status,
}: IUploadListItemProps) => {
  const language = useCurrentLanguage()

  const UPLOAD_LIST_ITEM_MODEL = useUploadListItemModel({
    fileExtension,
    fileSize,
    uploadDate,
    documentId,
    onDelete,
    language,
  })

  return (
    <UploadListItemView {...UPLOAD_LIST_ITEM_MODEL} status={status} fileExtension={fileExtension} disabled={disabled}>
      {children}
    </UploadListItemView>
  )
}

export const UploadListItem = memo(Component)
